import "antd/es/divider/style";
import _Divider from "antd/es/divider";
import "antd/es/col/style";
import _Col from "antd/es/col";
import "antd/es/row/style";
import _Row from "antd/es/row";
import "antd/es/checkbox/style";
import _Checkbox from "antd/es/checkbox";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useContext } from 'react';
import { LocaleContext } from '../locale';
import Typography from '../typography';

function handleFilterDisable() {
  var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var disable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (disable.length === 0) {
    return all;
  }

  return all.filter(function (item) {
    return !disable.includes(item);
  });
}

var CreateCheckBoxFilter = function CreateCheckBoxFilter(props) {
  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var title = props.title,
      _props$configList = props.configList,
      configList = _props$configList === void 0 ? [] : _props$configList,
      optionKey = props.optionKey,
      _props$allSelected = props.allSelected,
      allSelected = _props$allSelected === void 0 ? [] : _props$allSelected,
      _props$chooseed = props.chooseed,
      chooseed = _props$chooseed === void 0 ? [] : _props$chooseed,
      disabled = props.disabled,
      _onChange = props.onChange,
      _props$setConfirmValu = props.setConfirmValue,
      setConfirmValue = _props$setConfirmValu === void 0 ? function () {} : _props$setConfirmValu,
      _props$handleOptionsC = props.handleOptionsChange,
      handleOptionsChange = _props$handleOptionsC === void 0 ? function () {} : _props$handleOptionsC;
  var timeKey = new Date();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      allChoose = _useState2[0],
      setAllChoose = _useState2[1];

  var nowValidList = handleFilterDisable(allSelected, disabled);
  useEffect(function () {
    // 有可能用户配置的可选大于实际能选中的
    if (chooseed.length >= nowValidList.length) {
      setAllChoose(true);
    } else {
      setAllChoose(false);
    }
  }, [chooseed.length, allSelected]);
  useEffect(function () {
    var filterDisabled = chooseed.filter(function (e) {
      return !(disabled === null || disabled === void 0 ? void 0 : disabled.includes(e));
    });

    if (filterDisabled.length !== chooseed.length) {
      handleOptionsChange({
        type: optionKey,
        value: filterDisabled
      });
      setConfirmValue(function (old) {
        return _objectSpread(_objectSpread({}, old), {}, _defineProperty({}, optionKey, filterDisabled));
      });
      typeof _onChange === 'function' && _onChange(filterDisabled);
    }
  }, [disabled]);
  return _jsxs("div", {
    className: "igloo-form-filter-drop-down-container-content-group",
    children: [_jsxs("div", {
      className: "igloo-form-filter-drop-down-container-content-group-title",
      children: [_jsx(Typography, {
        level: "h4",
        children: title
      }), allChoose ? _jsx("span", {
        className: "igloo-form-filter-drop-down-container-content-group-title-action",
        onClick: function onClick() {
          typeof _onChange === 'function' && _onChange([]);
          handleOptionsChange({
            type: optionKey,
            value: []
          });
          setAllChoose(false);
        },
        children: _jsx(Typography, {
          level: "h4",
          children: formatMessage({
            id: 'Unselect All'
          })
        })
      }) : _jsx("span", {
        className: "igloo-form-filter-drop-down-container-content-group-title-action",
        onClick: function onClick() {
          typeof _onChange === 'function' && _onChange(nowValidList);
          handleOptionsChange({
            type: optionKey,
            value: nowValidList
          });
          setAllChoose(true);
        },
        children: _jsx(Typography, {
          level: "h4",
          children: formatMessage({
            id: 'Select All'
          })
        })
      })]
    }), _jsx(_Checkbox.Group, {
      value: handleFilterDisable(chooseed, disabled),
      style: {
        width: '100%'
      },
      onChange: function onChange(e) {
        typeof _onChange === 'function' && _onChange(e);
        handleOptionsChange({
          type: optionKey,
          value: e
        });
      },
      children: _jsx(_Row, {
        gutter: [24, 16],
        children: configList.map(function (item) {
          return _jsx(_Col, {
            span: item.span || 8,
            children: _jsx(_Checkbox, {
              value: item.value,
              disabled: disabled === null || disabled === void 0 ? void 0 : disabled.includes(item.value),
              children: _jsx(Typography, {
                level: "body1",
                children: item.label
              })
            })
          }, item.value);
        })
      })
    }, String(timeKey.valueOf())), _jsx(_Divider, {
      style: {
        margin: '16px 0px'
      }
    })]
  }, optionKey);
};

export default CreateCheckBoxFilter;